import { useEffect } from 'react';

/**
 * Intercepts browser Back / Forward (history traversal) for this SPA.
 *
 * Chrome cannot hide or grey out those toolbar buttons; this only changes what happens
 * when they are used — same-origin navigation via history is re-pinned so the session
 * does not walk backward/forward through the stack unintentionally.
 *
 * Set REACT_APP_LOCK_BROWSER_HISTORY=0 in .env to disable (e.g. local debugging).
 */
export default function BrowserHistoryLock() {
  useEffect(() => {
    if (typeof window === 'undefined' || !window.history?.pushState) return;
    if (String(process.env.REACT_APP_LOCK_BROWSER_HISTORY || '').trim() === '0') return;

    const originAtMount = window.location.origin;

    const stillOnThisApp = () => window.location.origin === originAtMount;

    // Cushion so the first Back/Forward traversal does not immediately leave the app tab.
    window.history.pushState(null, '', window.location.href);
    window.history.pushState(null, '', window.location.href);

    let burst = 0;
    const onPopState = () => {
      if (!stillOnThisApp()) return;
      burst += 1;
      if (burst > 14) {
        burst = 0;
        return;
      }
      try {
        window.history.pushState(null, '', window.location.href);
      } finally {
        window.queueMicrotask(() => {
          burst = 0;
        });
      }
    };

    window.addEventListener('popstate', onPopState, true);
    return () => {
      window.removeEventListener('popstate', onPopState, true);
    };
  }, []);

  return null;
}
